import { render, staticRenderFns } from "./SectionTopic.vue?vue&type=template&id=448212ea&"
import script from "./SectionTopic.vue?vue&type=script&lang=js&"
export * from "./SectionTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports